import { useState } from "react";
import { configParameters, remoteConfig } from "./common";
import { useMediaQuery } from "./useMediaQuery";
var KEY_THEME = "theme";
export var Theme;
(function (Theme) {
    Theme["LIGHT"] = "light";
    Theme["DARK"] = "dark";
    Theme["DEFAULT"] = "light";
})(Theme || (Theme = {}));
export var useTheme = function () {
    var config = remoteConfig();
    var savedTheme = localStorage.getItem(KEY_THEME);
    var requestedDark = useMediaQuery("(prefers-color-scheme: dark)") && config.getBoolean(configParameters.allowDynamicTheme);
    var initTheme;
    if (savedTheme)
        initTheme = savedTheme;
    else if (requestedDark)
        initTheme = Theme.DARK;
    else
        initTheme = Theme.LIGHT;
    var _a = useState(initTheme), theme = _a[0], setTheme = _a[1];
    return { current: theme, setTheme: function (th) {
            localStorage.setItem(KEY_THEME, th);
            setTheme(th);
        } };
};
//# sourceMappingURL=useTheme.js.map